<template>
  <div>
    <div :class="{'question-block': sender, 'answer-block': !sender}">
      <div :class="{'message-question': sender, 'message-answer': !sender}">
        <div class="text-message-right-2" :class="{'text-message-right-2': sender, 'text-message-left': !sender}" v-if="!getUrl(content)">{{
            content
          }}<br>
        </div>
        <div style="display:inline-block;" class="text-message-right-2" v-else>
          <span v-for="(c, index) in content.split(' ')" :key="`link-${index}`">
            <span v-if="!(c.match(/\bhttps?:\/\/\S+/gi) || c.match(/[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi))">{{c}}&nbsp;</span>
            <a target="_blank" :href="c.includes('http') ? c : `https://${c}`" v-else>{{ c }}&nbsp;</a>
          </span>
        </div>
        <div class="file-to-download" v-if="file">
          <img
              src="https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/6836d8795ff7357d9216c7b4_uploaded.png"

              loading="lazy" width="25" height="25" alt="">

          <a :href="file" class="download-link-3">{{ fileName ? fileName : 'bez_názvu' }}</a>
        </div>
      </div>
      <img
          v-if="seen"
          src="https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/6836d87216294c75141f8962_messagereaded.png"
          loading="lazy" alt="" class="notread-message-icon">
    </div>
  </div>
</template>

<script>
export default {
  name: "Message",
  props: {
    sender: Boolean,
    content: String,
    file: String,
    fileName: String,
    seen: Boolean
  },
  data() {
    return {
      contentAfterUrl: null
    }
  },
  methods: {
    getUrl(url) {
      const wHttp = url.match(/\bhttps?:\/\/\S+/gi);

      if (wHttp)
        return wHttp
      return url.match(/[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi);
    },
  }
}
</script>

<style lang="scss" scoped>
.message-question, .message-answer {
  max-width: none;
  overflow-wrap: anywhere;
}

</style>
